// Import React and Link component from react-router-dom library
import React from 'react'
import { Link } from 'react-router-dom'

// Define NotFound functional component
const NotFound = () => {
  // Render a div that contains a header and a Link component that redirects to Home page
  return (
    <div className="container-fluid">
      <h1>404 - Page not found!</h1>
      <Link to="/">back to Home</Link>
    </div>
  )
}

// Export NotFound component as default export
export default NotFound